<template>
    <div v-if="value">
        <div role="link" class="interior-list" @click="onClick">
            <span class="interior-list__thumb">
                <span class="interior-list__thumbnail">
                    <span class="interior-list__thumbnail-image" :style="{ backgroundImage: `url('${value.thumb}')` }"></span>
                </span>
            </span>
            <div>
                <span class="interior-list__title">{{ value.subject }}</span>
                <ul class="interior-list__infos">
                    <li class="interior-list__info">{{ value.category.name }}</li>
                    <li class="interior-list__info">{{ value.construction.acreage }}평대</li>
                    <li v-if="!value.construction.discountPrice" class="interior-list__info">{{ (value.construction.supplyPrice || 0).format() }}만원대</li>
                    <li v-else class="interior-list__info">
                        {{ (value.construction.discountPrice || 0).format() }}만원<span>({{ (value.construction.supplyPrice || 0).format() }}만원)</span>대
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: { type: Object, default: null },
        isSearch: { type: Boolean, default: false },
    },
    methods: {
        onClick() {
            const { $router, $route, value, isSearch } = this;
            if (isSearch) $router.push(`/portfolio/resident/${value._id}`);
            else $router.push(`${$route.path}/${value._id}`);
        },
    },
};
</script>

<style lang="css" scoped></style>
